export default {
  control: (styles, { isFocused, menuIsOpen, isDisabled }) => {
    return {
      ...styles,
      backgroundColor: isDisabled ? '#e7e7e7 !important' : '#eaeaea !important',
      boxShadow: isFocused || menuIsOpen ? '0 0 0 0.05rem #c0b4ff' : 'none',
      border: '1px solid #eaeaea',
      fontSize: '13px',
      borderRadius: '8px',
      minHeight: '35px',
      height: 'auto',
      "&:hover": {
        // border: '1px solid #dddddd',
      },
    }
  },
  singleValue: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? "#999999" : '#000 !important',
    fontSize: '13px',
  }),
  indicatorsContainer: (styles, state) => ({
    ...styles,
    height: '-webkit-fill-available',

  }),
  menuPortal: (styles, state) => ({
    ...styles,
    zIndex: 1000
  }),
  menu: (styles, state) => ({
    ...styles,
    zIndex: 2000
  }),
  indicatorContainer: (styles, state) => ({
    ...styles,
    padding: '0px !important',
    alignItems: 'center'
  }),
  indicatorSeparator: (styles, state) => ({
    ...styles,
    display: "none",
  }),
  dropdownIndicator: (styles, { isDisabled }) => ({
    ...styles,
    // color: '#36214880 !important',
    color: isDisabled ? "#cccccc" : '#36214880 !important',
    // background: '#c0b4ff !important',
    background: isDisabled ? "#d4d4d4" : '#c0b4ff !important',
    borderRadius: '8px !important',
    padding: '7px 8px !important',
    alignItems: 'center',
    height: "100%",
  }),
  valueContainer: (styles, state) => ({
    ...styles,
    display: "flex",
    flexDirection: "row",
    overflowX: "hidden",
    paddingTop: '0px',
    paddingBottom: '0px',
    flexWrap: 'wrap'
  }),
  placeholder: (styles, state) => ({
    ...styles,
    color: '#362148 !important'
  }),
  multiValue: (styles, state) => ({
    ...styles,
    minWidth: "auto",
    backgroundColor: "#fafafa"
  }),
  groupHeading: (styles) => ({
    ...styles,
    padding: "6px 5px",
    background: "#cccccc3d",
    lineHeight: 1
  }),
  multiValueRemove: (base, state) => {
    return state.data.isFixed ? { ...base, display: 'none' } : base;
  },
  noOptionsMessage: (styles) => ({
    ...styles,
    fontSize: "13px"
  }),
  loadingMessage: (styles) => ({
    ...styles,
    fontSize: "13px"
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => {
    return {
      ...styles,
      color: isSelected ? '#fff !important' : '#000000a6 !important',
      padding: '4px 5px',
      alignItems: 'center',
      width: 'auto',
      marginBottom: '0px',
      fontSize: '13px',
      display: 'flex',
      lineHeight: '22px',
      cursor: isDisabled ? "not-allowed" : "initial",
      backgroundColor: isSelected ? '#b8acf4 !important' : isDisabled ? "#e5e5e5" : '#fff !important',
      "&:hover": {
        backgroundColor: (isSelected) ? '#b8acf4 !important' : isDisabled ? "#e5e5e5" : '#b8acf480 !important',
      },
    };
  },
};
